var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.contentPosition") } },
    [
      _c(
        "el-select",
        {
          model: {
            value: _vm.optionModel.contentPosition,
            callback: function ($$v) {
              _vm.$set(_vm.optionModel, "contentPosition", $$v)
            },
            expression: "optionModel.contentPosition",
          },
        },
        [
          _c("el-option", { attrs: { label: "center", value: "center" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "left", value: "left" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "right", value: "right" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }